import {ngAsync} from 'shared/utils/ng-@decorators';
import {responseToData, transferify, unRestangularize} from 'shared/utils/data-service-utils';
import type {ActionResponse} from 'typings/portaro.be.types';

/**
 * @ngdoc service
 * @name remoteMvsDataService
 * @module portaro.uc.user
 *
 * @requires Restangular
 *
 * @description
 * Data service for providing exemplar exchange between buildings
 */
export default class RemoteMvsDataService {
    public static readonly serviceName = 'remoteMvsDataService';
    public static readonly SEND_ROUTE = 'mvs-remote/send';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async send(object: any): Promise<ActionResponse> {
        try {
            return await this.Restangular
                .one(RemoteMvsDataService.SEND_ROUTE)
                .post<ActionResponse>(null, transferify(object));
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }
}
